import { createFileRoute, retainSearchParams } from "@tanstack/react-router"

import PermissionContentWrapper from "@/components/PermissionWrapper/PermissionContentWrapper"
import { PermissionActionType } from "@/constants/permissions"
import { ChartOfAccountsContainer } from "@/screens/Accounting/subfeatures/ChartOfAccounts"
import { ChartOfAccountsSearchParamsSchema } from "@/screens/Accounting/subfeatures/ChartOfAccounts/types/searchParams"

export const Route = createFileRoute("/app/admin/accounting/_layout/accounts-chart")({
  validateSearch: ChartOfAccountsSearchParamsSchema,
  search: {
    middlewares: [
      retainSearchParams([
        "field",
        "order",
        "query",
        "classification",
        "accountTypes",
        "reportingAccountType",
        "showInactive",
      ]),
    ],
  },
  component: () => (
    <PermissionContentWrapper
      permissions={[
        PermissionActionType.ACCOUNTING_VIEW,
        PermissionActionType.ACCOUNTING_MANAGER,
        PermissionActionType.ACCOUNTING_MAINTENANCE,
      ]}
    >
      <ChartOfAccountsContainer />
    </PermissionContentWrapper>
  ),
})
